import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  featuredJobs,
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useLocation, useNavigate } from "react-router-dom";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  _get_JD_list_blog_api,
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
  get_favourites_job_api,
  sourceListApi,
} from "../../DAL/partner/partners";
import PageLoading from "../../components/loader/PageLoading";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import { s3baseUri } from "../../config/config";
import moment from "moment";
import SkeletonJObs from "../loader/jbsSkeleton";
import SkeletonFavoiriteJobs from "../loader/FavouriteJobSkeleton";

export default function FavouriteJobs() {
  const navigate = useNavigate();
  const { findId, setBreadCrumb, userInfo } = useIds();
  const apiData = localStorage.getItem("side_bar_data");

  console.log(userInfo, "userInfouserInfo");
  let data_array = apiData ? JSON.parse(apiData) : null;

  console.log(data_array, "data_adata_arraydata_arraydata_arrayrraydata_array");

  const location = useLocation();
  const filteredData =
    userInfo?.type === 2
      ? data_array?.filter((item) =>
          userInfo?.source?.some((source) => source?.source_id === item._id)
        )
      : data_array;

  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openDetail, setOpenDetail] = useState(false);
  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const formatSalaryFrequency = (frequency) => {
    switch (frequency) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { pathname } = useLocation();
  const [partnersObj, setPartnersObj] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [page, setPage] = useState(0);

  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [editMode, setEditMode] = useState(false);
  const [membersList, setMembersList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedFilter, setSelectedFilter] = useState(filteredData[0]?._id);
  const [filter, setfilter] = useState("");

  const load_more_path = "api/jobs/favorite_job_list?page=0&limit=40";
  console.log(findId, "findIdfindId");
  console.log(partnersObj, "partnersObjpartnersObjpartnersObj");
  let icon = {
    iconBg: "#000080",
  };
  const handleNavigateAppliedJobs = () => {
    console.log("callled");
    navigate(`/favourite-jobs/applied-jobs`, { state: { routePath: "home" } });
  };

  const handleOpenDetail = (job) => {
    navigate(`/favourite-jobs/detail/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidiates = (job) => {
    navigate(`/favourite-jobs/candidates/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const fetchCategories = async (path, search, loading, id) => {
    const finalId = id ?? selectedFilter;
    console.log(finalId, "finalIdfinalId");

    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }

    // if (!id) {
    //   id = localStorage.getItem("source_id");
    //   console.log(id, "ididididid");
    // }
    const response = await get_favourites_job_api(finalId, search, path);
    console.log(response, "responseresponseresponse");
    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response?.jobs[i].job_applicants?.length; j++) {
        if (
          user_info?.user_id?._id ===
          response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }
    console.log(response, "responseresponseresponse jobs");

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);
      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }
      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, searchTerm, true, selectedFilter);
  };

  let login_nfo = localStorage.getItem("user");
  console.log(login_nfo, "login_nfologin_nfologin_nfologin_nfo");
  let user_info = login_nfo ? JSON.parse(login_nfo) : null;
  console.log(user_info, "Parsed user_info");
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );
  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchTerm, false, selectedFilter);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm]);

  useEffect(() => {
    fetchCategories(load_more_path, searchTerm, false, selectedFilter);
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
    ]);
  }, []);
  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);

  if (loading) {
    // return <PageLoading />;
    return <SkeletonFavoiriteJobs />;
  }
  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick(row) {
        handleOpenEditJob(row);
      },
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
    },
  ];
  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId];

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
        fetchCategories(load_more_path, searchTerm, false, selectedFilter);
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handlePersonalJob = () => {
    console.log("callled");
    navigate(`/${firstSegment}/live-job-feed/personal-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);
    // setfilter(selectedFilter);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);
    console.log("Deleting Member ID:", id);

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, selectedFilter);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  const handleDelete = (row) => {
    console.log(row._id, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };
  const handleFilterChange = (event) => {
    const selectedId = event.target.value;
    setSelectedFilter(selectedId);
    fetchCategories(load_more_path, searchTerm, false, selectedId);
    console.log(selectedId, "selectedIdselectedIdselectedIdselectedId");
  };

  return (
    <>
      <PostJobModal
        refreshlist={fetchCategories}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        jobData={selectedJob} // Pass selected job data when editing
        sourceId={sourceId}
        selectedFilter={selectedFilter}
        filter={filter}
      />

      <PostJobDetail
        cv={cv}
        open={openDetail}
        setCv={setCv}
        job={selectedJob}
        handleClose={handleCloseDetail}
      />
      {isMobile ? (
        <div className="container-fluid px-2">
          <div className="row">
            <div className="mt-3 mb-4 col-12">
              <div className="card-body mt-1 main-heading-live-jobs jobs-live-main">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
                  <h2 className="ml-md-4 mb-2 mb-md-0">Live Jobs Feed</h2>
                  <div className="d-flex flex-column flex-sm-row gap-3 w-100">
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      placeholder="Search by Job Title, Description"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      sx={{ minWidth: 280, flexGrow: 1 }}
                      InputProps={{
                        sx: {
                          "& input::placeholder": {
                            color: "#b0b0b0",
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <FormControl fullWidth size="small" variant="outlined">
                      <InputLabel sx={{ fontSize: 14 }}>
                        Filter by Title
                      </InputLabel>
                      <Select
                        value={selectedFilter}
                        onChange={handleFilterChange}
                        label="Filter by Title"
                        sx={{ fontSize: 14 }}
                      >
                        {filteredData?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                            sx={{ fontSize: 14 }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* <button
                      className="small-button-contain-job-live"
                      onClick={handleNavigateAppliedJobs}
                    >
                      <CheckCircleOutlineIcon
                        style={{
                          fontSize: "18px",
                          color: "#fff",
                        }}
                      />{" "}
                      Applied Job
                    </button> */}
                  </div>
                </div>

                <Box className="row" mt={4}>
                  {categories.length > 0 ? (
                    categories.map((job, index) => (
                      <div
                        key={index}
                        className="col-12 col-md-6 col-lg-4 mb-3"
                      >
                        <Card
                          onClick={() => handleOpenDetail(job)}
                          variant="outlined"
                          className="mui-card h-100"
                          sx={{
                            borderRadius: 2,
                            mb: 2,
                            p: 2,
                            border: "2px solid transparent !important", // Normal state: no visible border
                            transition: "all 0.3s ease",
                            "&:hover": {
                              border: "2px solid #DAA520 !important",
                            },
                            cursor: "pointer",
                          }}
                        >
                          <CardContent className="card-content-mui">
                            <Box
                              display="flex"
                              flexDirection={{ xs: "column", sm: "row" }}
                              justifyContent="space-between"
                              alignItems={{ xs: "flex-start", sm: "center" }}
                              gap={2}
                            >
                              {/* Profile and Job Title */}
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                                width="100%"
                              >
                                <Avatar
                                  src={
                                    s3baseUri + job?.creater_info?.profile_image
                                  }
                                  alt=""
                                  style={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                  onClick={() => handleOpenDetail(job)}
                                />
                                <Box>
                                  <Typography
                                    variant="h6"
                                    className="ms-3"
                                    fontWeight="bold"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handleOpenDetail(job)}
                                  >
                                    {job.jobTitle}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    className="ms-3"
                                    color="textSecondary"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handleOpenDetail(job)}
                                  >
                                    {job.location} •{" "}
                                    <span
                                      style={{
                                        color: "navy",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {moment(job.createdAt).fromNow()}
                                    </span>
                                  </Typography>
                                </Box>
                              </Box>

                              {/* Icons on right */}
                              <Box display="flex" gap={1} flexWrap="wrap">
                                {job.created_by === userInfo?.user_id?._id && (
                                  <Chip
                                    label="My Job"
                                    variant="outlined"
                                    color="primary"
                                  />
                                )}
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation(); // This stops the event from bubbling up
                                    handleBookmarkToggle(job._id);
                                  }}
                                >
                                  {bookmarkedJobs[job._id] ? (
                                    <BookmarkIcon sx={{ color: "#000080" }} />
                                  ) : (
                                    <BookmarkBorderIcon />
                                  )}
                                </IconButton>
                                {job.created_by === userInfo?.user_id?._id && (
                                  <div onClick={(e) => e.stopPropagation()}>
                                    <CustomPopoverSection
                                      menu={MENU_OPTIONS}
                                      data={job}
                                    />
                                  </div>
                                )}
                              </Box>
                            </Box>

                            {/* Tags and Chips */}
                            <Box display="flex" gap={1} flexWrap="wrap" my={2}>
                              <Chip label={job.jobType} variant="outlined" />
                              <Chip
                                label={show_des_data(job.experienceRequired)}
                                variant="outlined"
                              />
                              <Chip
                                label={formatEducationRequired(
                                  job.educationRequired
                                )}
                                variant="outlined"
                              />
                            </Box>

                            {/* Description */}
                            <Typography
                              variant="body1"
                              sx={{
                                mt: 2,
                                fontSize: "15px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleOpenDetail(job)}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html:
                                    job.description.length > 300
                                      ? `${job.description.slice(0, 300)}...`
                                      : job.description,
                                }}
                              />
                              {job.description.length > 300 && (
                                <span
                                  style={{
                                    color: "navy",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Read More
                                </span>
                              )}
                            </Typography>

                            {/* Salary and Apply */}
                            <Box
                              display="flex"
                              flexDirection={{ xs: "column", sm: "row" }}
                              justifyContent="space-between"
                              alignItems={{ xs: "flex-start", sm: "center" }}
                              mt={2}
                              gap={2}
                            >
                              <Box display="flex" flexDirection="row" gap={1}>
                                {job.salaryType === "range" ? (
                                  <>
                                    <Chip
                                      variant="outlined"
                                      className="mui-chip"
                                      label={`Min Salary: €${job.minSalary}/${
                                        job.frequencySalary
                                          ? job.frequencySalary.toLowerCase()
                                          : ""
                                      }`}
                                      onClick={() => handleOpenDetail(job)}
                                      sx={{ cursor: "pointer" }}
                                    />
                                    <Chip
                                      className="mui-chip"
                                      variant="outlined"
                                      label={`Max Salary: €${job.maxSalary}/${
                                        job.frequencySalary
                                          ? job.frequencySalary.toLowerCase()
                                          : ""
                                      }`}
                                      onClick={() => handleOpenDetail(job)}
                                    />
                                  </>
                                ) : job.salaryType === "fixed" ? (
                                  <Chip
                                    className="mui-chip"
                                    variant="outlined"
                                    label={`Fixed Salary: €${job.salary}/${
                                      job.frequencySalary
                                        ? job.frequencySalary.toLowerCase()
                                        : ""
                                    }`}
                                    onClick={() => handleOpenDetail(job)}
                                  />
                                ) : null}
                              </Box>

                              <Box display="flex" gap={2} flexWrap="wrap">
                                {job.created_by === userInfo?.user_id?._id &&
                                  userInfo?.type === 2 && (
                                    <div className="position-relative">
                                      <div
                                        className="badge position-absolute"
                                        style={{
                                          top: "-7px",
                                          right: "-6px",
                                          backgroundColor: "#FF0000",
                                          color: "#fff",
                                          padding: "2px 6px",
                                          borderRadius: "12px",
                                          minWidth: "20px",
                                          textAlign: "center",
                                          fontSize: "12px",
                                          lineHeight: "1.2",
                                        }}
                                      >
                                        {job?.job_applicants?.length || 0}
                                      </div>
                                      <button
                                        className="small-button-contain-job-candidates"
                                        onClick={() => handleCandidiates(job)}
                                      >
                                        View Candidates
                                      </button>
                                    </div>
                                  )}
                                {userInfo.user_id._id !== job.created_by ? (
                                  job.created_by_me ? (
                                    <span>
                                      <CheckCircleOutlineIcon
                                        style={{
                                          color: "#4CAF50",
                                          marginRight: "2px",
                                        }}
                                      />
                                      Applied
                                    </span>
                                  ) : (
                                    <button
                                      className="small-button-contain-job"
                                      onClick={() => handleOpenDetail(job)}
                                    >
                                      Apply Job
                                    </button>
                                  )
                                ) : (
                                  <button
                                    className="small-button-contain-job"
                                    onClick={() => handleOpenDetail(job)}
                                  >
                                    View Detail
                                  </button>
                                )}
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </div>
                    ))
                  ) : (
                    <div>
                      <RecordNotFound title="No jobs" />
                    </div>
                  )}

                  {totalPages >= pageNumber && (
                    <div className="col-12 text-center mt-3">
                      <span
                        ref={lastBookElementRef}
                        className="mt-3"
                        onClick={loadMoreData}
                        id="load-more-feed"
                      >
                        {isLoadingMore ? (
                          <CircularProgress color="primary" size="1.5rem" />
                        ) : (
                          "Load More"
                        )}
                      </span>
                    </div>
                  )}
                </Box>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="mt-3 mb-4">
              <div className="card-body mt-1 main-heading-live-jobs jobs-live-main">
                <div className="d-flex justify-content-between mb-3">
                  <h2 className="ml-4">Favourite Jobs </h2>
                  <div className="d-flex gap-2">
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="Search by Job Title, Description"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      sx={{ minWidth: 280, flexGrow: 1 }}
                      InputProps={{
                        sx: {
                          "& input::placeholder": {
                            color: "#b0b0b0",
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <FormControl
                      variant="outlined"
                      sx={{ minWidth: 150, width: 200, height: 40 }}
                    >
                      <InputLabel sx={{ fontSize: 14 }}>
                        Filter by Title
                      </InputLabel>
                      <Select
                        value={selectedFilter}
                        onChange={handleFilterChange}
                        label="Filter by Title"
                        sx={{ height: 40, fontSize: 14 }}
                      >
                        {filteredData?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                            sx={{ fontSize: 14 }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* <button
                      className="small-button-contain-job-live"
                      onClick={handleNavigateAppliedJobs}
                    >
                      <CheckCircleOutlineIcon
                        style={{
                          fontSize: "18px",
                          color: "#fff",
                        }}
                      />{" "}
                      Applied Job
                    </button> */}

                    {/* <button
                    className="small-button-contain-job-live"
                    onClick={() => handlePersonalJob()}
                  >
                    My Job Posts
                  </button>
                  <button
                    className="small-button-contain-job-live"
                    onClick={handleOpen}
                  >
                    <PostAddOutlinedIcon className="post-add-icon" />
                    Post Job
                  </button> */}
                  </div>
                </div>

                <Box className="row " mt={4}>
                  {categories.length > 0 ? (
                    categories.map((job, index) => (
                      <div key={index} className="col-12 mb-3">
                        {" "}
                        {/* Full width card */}
                        <Card
                          onClick={() => handleOpenDetail(job)}
                          variant="outlined"
                          className="mui-card"
                          sx={{
                            borderRadius: 2,
                            mb: 2,
                            p: 2,

                            border: "2px solid transparent !important", // Normal state: no visible border
                            transition: "all 0.3s ease",
                            "&:hover": {
                              border: "2px solid #DAA520 !important",
                            },
                            position: "relative", // Added for positioning the badge
                            cursor: "pointer",
                          }}
                        >
                          {job.status === false && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                backgroundColor: "#d32f2f",
                                color: "white",
                                padding: "2px 5px",
                                fontWeight: "bold",
                                borderRadius: "0 0 10px 0", // Rounded corner on the right side
                                zIndex: 1, // Ensures it stays above other content
                                fontSize: "12px",
                              }}
                            >
                              Inactive
                            </Box>
                          )}
                          <CardContent className="card-content-mui">
                            {/* Header */}
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box
                                  onClick={() => handleOpenDetail(job)}
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <Avatar
                                    src={
                                      s3baseUri +
                                      job?.creater_info?.profile_image
                                    }
                                    alt=""
                                    style={{
                                      width: 50,
                                      height: 50,
                                      borderRadius: "50%", // Optional: makes it circular like a typical profile icon
                                      objectFit: "cover",
                                    }}
                                  />{" "}
                                </Box>
                                <Box>
                                  <div className="d-flex">
                                    <Typography
                                      onClick={() => handleOpenDetail(job)}
                                      variant="h6"
                                      className="ms-3"
                                      fontWeight="bold"
                                      sx={{ cursor: "pointer" }}
                                    >
                                      {job.jobTitle}{" "}
                                    </Typography>
                                  </div>

                                  <Typography
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handleOpenDetail(job)}
                                    variant="body2"
                                    className="ms-3"
                                    color="textSecondary"
                                  >
                                    {job.location} •{" "}
                                    <span
                                      style={{
                                        color: "navy",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {moment(job.createdAt).fromNow()}
                                    </span>
                                  </Typography>
                                </Box>
                              </Box>
                              <div className="d-flex">
                                {job.created_by === user_info?.user_id?._id && (
                                  <Chip
                                    className="mui-chip"
                                    label="My Job"
                                    variant="outlined"
                                    color="primary"
                                  />
                                )}
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation(); // This stops the event from bubbling up
                                    handleBookmarkToggle(job._id);
                                  }}
                                >
                                  {bookmarkedJobs[job._id] ? (
                                    <BookmarkIcon sx={{ color: "#000080" }} />
                                  ) : (
                                    <BookmarkBorderIcon />
                                  )}
                                </IconButton>
                                {job.created_by === user_info?.user_id?._id && (
                                  <div onClick={(e) => e.stopPropagation()}>
                                    <CustomPopoverSection
                                      menu={MENU_OPTIONS}
                                      data={job}
                                    />
                                  </div>
                                )}
                              </div>
                            </Box>

                            {/* Job Tags */}
                            <Box
                              display="flex"
                              gap={1}
                              my={2}
                              justifyContent="space-between"
                              onClick={() => handleOpenDetail(job)}
                            >
                              {/* Left-aligned chips */}
                              <Box display="flex" gap={1}>
                                <Chip
                                  className="mui-chip"
                                  label={job.jobType}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  // label={job.experienceRequired}
                                  label={show_des_data(job?.experienceRequired)}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  // label={job.experienceRequired}
                                  label={formatEducationRequired(
                                    job?.educationRequired
                                  )}
                                  variant="outlined"
                                />
                              </Box>

                              {/* Right-aligned "Personal Job" chip (only if applicable) */}
                            </Box>

                            <Typography
                              variant="body1"
                              sx={{
                                mt: 2,
                                fontSize: "15px",
                                cursor: "pointer",
                                display: "inline",
                                mb: 0,
                              }}
                              onClick={() => handleOpenDetail(job)}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html:
                                    job.description.length > 300
                                      ? `${job.description.slice(0, 300)}...`
                                      : job.description,
                                }}
                              />

                              {job.description.length > 300 && (
                                <span
                                  style={{
                                    color: "navy",
                                    cursor: "pointer",
                                    textDecoration: "underline", // Added this line
                                  }}
                                  onClick={() => handleOpenDetail(job)}
                                >
                                  Read More
                                </span>
                              )}
                            </Typography>

                            {/* Salary & Apply */}
                            <Box display="flex" flexDirection="row" gap={1}>
                              {job.salaryType === "range" ? (
                                <>
                                  <Chip
                                    variant="outlined"
                                    className="mui-chip"
                                    label={`Min Salary: €${job.minSalary}/${
                                      job.frequencySalary
                                        ? job.frequencySalary.toLowerCase()
                                        : ""
                                    }`}
                                    onClick={() => handleOpenDetail(job)}
                                    sx={{ cursor: "pointer" }}
                                  />
                                  <Chip
                                    className="mui-chip"
                                    variant="outlined"
                                    label={`Max Salary: €${job.maxSalary}/${
                                      job.frequencySalary
                                        ? job.frequencySalary.toLowerCase()
                                        : ""
                                    }`}
                                    onClick={() => handleOpenDetail(job)}
                                  />
                                </>
                              ) : job.salaryType === "fixed" ? (
                                <Chip
                                  className="mui-chip"
                                  variant="outlined"
                                  label={`Fixed Salary: €${job.salary}/${
                                    job.frequencySalary
                                      ? job.frequencySalary.toLowerCase()
                                      : ""
                                  }`}
                                  onClick={() => handleOpenDetail(job)}
                                />
                              ) : null}
                            </Box>
                          </CardContent>
                        </Card>
                      </div>
                    ))
                  ) : (
                    <div>
                      <RecordNotFound title="No jobs" />
                    </div>
                  )}
                  {totalPages >= pageNumber ? (
                    <div className="col-12 text-center mt-3">
                      <span
                        ref={lastBookElementRef}
                        className="mt-3"
                        onClick={loadMoreData}
                        id="load-more-feed"
                      >
                        {isLoadingMore ? (
                          <CircularProgress color="primary" size="1.5rem" />
                        ) : (
                          "Load More"
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </Box>
              </div>
            </div>
          </div>
        </div>
      )}

      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this job?"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </>
  );
}
